import './index.scss';

import {inject, observer} from 'mobx-react';
import {Swiper, SwiperSlide} from 'swiper/react';
import Prevent from '../Prevent';
import {Pagination} from 'swiper';
import SightHotelItem from '../SightHotelItem';

@inject(({store}) => {
    return {
        sights: store.sights
    };
})
@observer
class Sights extends React.Component {
    render() {
        const {sights} = this.props;
        if (!sights.length) {
            return null;
        }
        return (
            <div className="sights">
                <img src="https://s.qunarzz.com/vacation_tuan/2023/abudhabi/title4.jpg" />
                <div className="sight">
                    {
                        sights.length && <Prevent>
                            <Swiper
                                ref={this.swiperRef}
                                initialSlide={0}
                                loop={true}
                                pagination
                                modules={[Pagination]}
                            >
                                {
                                    sights.map((sight, sIndex) => {
                                        return (
                                            <SwiperSlide className="sight" key={sIndex}>
                                                {
                                                    sight && sight.map((item, index) => {
                                                        return <SightHotelItem
                                                            data={item}
                                                            type="sight"
                                                            key={index}
                                                            eIndex={(sIndex * 4 + index + 1) > 9 ? (sIndex * 4 + index + 1) : '0' + (sIndex * 4 + index + 1)}
                                                        />;
                                                    })
                                                }
                                            </SwiperSlide>
                                        );
                                    })
                                }
                            </Swiper>
                        </Prevent>
                    }
                </div>
            </div>
        );
    }
}

export default Sights;